import request from '../request'
export default {
    /**
     * 登录
     */
    // login: (para, suss, err) => request.request('client/sys/applicationLogin', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),

    /**
     * 我的任务列表
     */
    myTaskList: (para, suss, err) => request.request('client/discoverProblem/myTaskList', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),

    /**
     * 放弃并回复
     */
    quitReport: (para, suss, err) => request.request('client/sq/quitReport', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),

    /**
     * 问题详情
     */
    clientsqdetail: (para, suss, err) => request.request('client/sq/reportDetail', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 创建或待处理编辑报告
     */
    reportEdit: (para, suss, err) => request.request('client/sq/reportEdit', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 解决问题列表
     */
    reportList: (para, suss, err) => request.request('client/sq/reportList', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 节点审核
     */
    reviewNode: (para, suss, err) => request.request('client/sq/reviewNode', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 发送外审
     */
    sendExternalReview: (para, suss, err) => request.request('client/sq/sendExternalReview', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 发送8D审核或评价
     */
    send8DReview: (para, suss, err) => request.request('client/sq/send8DReview', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),

    /**
     * 下载8D报告
     */
    downloadReport: (para, suss, err) => request.request('client/sq/downloadReport', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 转发8D报告
     */
    transferReport: (para, suss, err) => request.request('client/sq/transferReport', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 审核流接口
     */
    getCheckFlow: (para, suss, err) => request.request('standByPlan/flow/getCheckFlow', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 解决D2-D8节点
     */
    dealwithNode: (para, suss, err) => request.request('client/sq/dealwithNode', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 问题审核通过
     */
    questionExaminePass: (para, suss, err) => request.request('client/examine/questionExaminePass', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 问题审核不通过
     */
    questionExamineBack: (para, suss, err) => request.request('client/examine/questionExamineBack', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 显示操作记录
     */
    oprRecordlist: (para, suss, err) => request.request('client/oprRecord/list', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 电子章
     */
    getStampByDetailId: (para, suss, err) => request.request('ent/stamp/getAllDeptStamp ', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 下载8D报告
     */
    sqgetPdfName: (para, suss, err) => request.request('client/sq/getPdfName', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * D4转换为D8
     */
    conversion: (para, suss, err) => request.request('/client/sq/conversion', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * SQEConfirm
     */
    SQEConfirm: (para, suss, err) => request.request('/client/discoverProblem/SQEConfirm', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 解决问题导出
     */
    exportsq: (para, suss, err) => request.request('client/sq/export', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 是否可以创建报告
     */
    checkMakeUp: (para, suss, err) => request.request('client/sq/checkMakeUp', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    

}


// WEBPACK FOOTER //
// ./src/api/mytask.js